export enum Mode {
  NORMAL,
  DARK,
}

export enum TradeMark {
  BLACK,
  WHITE,
}
